import React, { useMemo, useState } from 'react';
import { createContextHook } from 'use-context-hook';

const context = {};

export const PendingApprovalsContext = createContextHook(context);

export function PendingApprovalsContextProvider({ children }) {
  const [totalCount, setTotalCount] = useState(null);

  const value = useMemo(
    () => ({
      totalCount,
      setTotalCount,
    }),
    [totalCount],
  );

  return <PendingApprovalsContext.Provider value={value}>{children}</PendingApprovalsContext.Provider>;
}
